import React from "react";
import { Link } from "react-router-dom";
import "./Portfolio.css";
import RichTextContent, { CmsText } from "../../../RichTextContent/RichTextContent";
import { useHomeSection } from "../../../../context/HomePageContext";
import { HiOutlineExternalLink } from "react-icons/hi";

const Portfolio = () => {
  const { section, loading } = useHomeSection("portfolio");

  if (loading || !section?.fields) return null;

  const fields = section.fields;

  return (
    <section className="portfolio">
      <div className="portfolio-content">
        {fields.subtitle ? (
          <CmsText
            content={fields.subtitle}
            as="p"
            className="portfolio-subtitle"
          />
        ) : null}

        {fields.title ? (
          <CmsText
            content={fields.title}
            as="h2"
            className="portfolio-title"
          />
        ) : null}

        {fields.description ? (
          <RichTextContent
            content={fields.description}
            className="portfolio-description"
          />
        ) : null}

        {fields.buttonLink ? (
          <Link to={fields.buttonLink} className="portfolio-btn buttonclip">
            <CmsText content={fields.buttonText} as="span" />
            <HiOutlineExternalLink className="arrow" aria-hidden />
          </Link>
        ) : null}
      </div>
    </section>
  );
};

export default Portfolio;
